import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { RotateCcw } from "lucide-react";
import { DatePickerWithRange } from "@/components/ui/date-range-picker";
import { DateRange } from "react-day-picker";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface MerchantReportFiltersProps {
  onDateRangeChange: (range: DateRange | undefined) => void;
  onReset: () => void;
  customDateRange?: DateRange;
  selectedProgram: string;
  onProgramChange: (programCode: string) => void;
  programs: Array<{ programCode: string; programName: string }>;
}

export const MerchantReportFilters: React.FC<MerchantReportFiltersProps> = ({
  onDateRangeChange,
  onReset,
  customDateRange,
  selectedProgram,
  onProgramChange,
  programs,
}) => {
  return (
    <Card className="mb-6 border-0 shadow-sm">
      <CardContent className="p-4">
        <div className="flex flex-wrap gap-3 items-center justify-between">
          <div className="flex gap-3 items-center">
            <Select value={selectedProgram} onValueChange={onProgramChange}>
              <SelectTrigger className="w-64 h-10">
                <SelectValue placeholder="Select Program" />
              </SelectTrigger>
              <SelectContent>
                {programs.map((program) => (
                  <SelectItem
                    key={program.programCode}
                    value={program.programCode}
                  >
                    {program.programName}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <div className="w-64 h-10 flex items-center">
              <DatePickerWithRange
                date={customDateRange}
                setDate={onDateRangeChange}
                placeholder="Select date range"
              />
            </div>
          </div>
          <div className="flex gap-2 items-center">
            <Button
              variant="outline"
              size="sm"
              className="flex items-center gap-2 px-3 py-2 text-sm h-10"
              onClick={onReset}
            >
              <RotateCcw className="h-4 w-4" />
              Reset
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
